// certified-by.tsx — the "Certified by / Microsoft Certified / DigiCert Secured" badge row
// under the signup form. Byte-identical between `sections/hero.tsx` and this module's sibling
// `trial-modal.tsx` (the hero form and the modal form are the same conversion unit rendered in
// two places), so it lives here once instead of being duplicated.
import { useTranslation } from 'next-i18next';

export function CertifiedBy() {
  const { t } = useTranslation('components/trial/lp/trial-beta');

  return (
    <div className='mt-4 flex items-center justify-center gap-5 pt-4' style={{ borderTop: '1px solid #2ECDFF15' }}>
      <span className='text-[10px] uppercase tracking-wider' style={{ color: '#929298', fontFamily: 'var(--font-outfit)' }}>
        {t('hero.certifiedBy')}
      </span>
      <div className='flex items-center gap-1.5'>
        <svg width='16' height='16' viewBox='0 0 21 21' className='shrink-0'>
          <rect x='1' y='1' width='9' height='9' fill='#F25022' />
          <rect x='11' y='1' width='9' height='9' fill='#7FBA00' />
          <rect x='1' y='11' width='9' height='9' fill='#00A4EF' />
          <rect x='11' y='11' width='9' height='9' fill='#FFB900' />
        </svg>
        <span className='text-[10px] font-semibold' style={{ color: '#A0A0B0', fontFamily: 'var(--font-outfit)' }}>
          {t('hero.microsoftCertified')}
        </span>
      </div>
      <div className='flex items-center gap-1.5'>
        <svg width='16' height='16' viewBox='0 0 24 24' fill='none' className='shrink-0'>
          <path d='M12 2L3 7v5c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5z' fill='#00A4EF' opacity='0.2' />
          <path d='M12 2L3 7v5c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-9-5z' stroke='#00A4EF' strokeWidth='1.5' fill='none' />
          <path d='M9 12l2 2 4-4' stroke='#fff' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
        <span className='text-[10px] font-semibold' style={{ color: '#A0A0B0', fontFamily: 'var(--font-outfit)' }}>
          {t('hero.digicertSecured')}
        </span>
      </div>
    </div>
  );
}
